import React from "react";
import styles from "./subheader.styles.css";

export default function({ text }) {
  if (text && text.trim()) {
    const className = `cps-color-primary-text ${styles.subheader}`;
    return <div className={className}>{text}</div>;
  } else {
    return <div className={styles.blankSubheader} />;
  }
}
